import { ShapeRegistry } from './registry';
import { MaterialHexagonShape } from './MaterialHexagonShape';
import { OperationPillShape } from './OperationPillShape';
import { CycleBracketShape } from './CycleBracketShape';

export { ShapeRegistry } from './registry';
export { MaterialHexagonShape } from './MaterialHexagonShape';
export { OperationPillShape } from './OperationPillShape';
export { CycleBracketShape } from './CycleBracketShape';

/** Registers the shapes bundled with the foundation layer. Idempotent. */
export function registerDefaultShapes(): void {
  ShapeRegistry.register('materialHexagon', MaterialHexagonShape);
  ShapeRegistry.register('operationPill', OperationPillShape);
  ShapeRegistry.register('cycleBracket', CycleBracketShape);
}
